import { render, staticRenderFns } from "./MoveIcon.vue?vue&type=template&id=07c85e76&scoped=true"
import script from "./MoveIcon.vue?vue&type=script&lang=js"
export * from "./MoveIcon.vue?vue&type=script&lang=js"
import style0 from "./MoveIcon.vue?vue&type=style&index=0&id=07c85e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c85e76",
  null
  
)

export default component.exports